import moment from 'moment';

import createReducer from 'reducers/createReducer';

import { Manager } from 'actions/actionTypes';

const INITIAL_STATE = {
    token: {
        accessToken: '',
        tokenType: '',
        refreshToken: '',
        expires: 0,
    },
    manager: {
        managerIdx: 0,
        managerId: '',
        managerName: '',
        managerType: '',
        shopGuid: '',
        shopName: '',
        isTestShop: false,
        signInStatus: null,
    },
    clientStatus: {
      sound: true,
      type: false,
    },
    updatePopupData: {
        isPopup: false,
        boardId: 0,
        title: '',
        content: '',
    },

    error: {
        triggered: false,
        message: ''
    },
};

const reducer = createReducer(INITIAL_STATE, {
    [Manager.CHANGE_UPDATE_POPUP_CLOSE]: (state, action) => {
        state.updatePopupData.isPopup = action.payload;
    },
    [Manager.CHANGE_UPDATE_CLIENTSTATUS_SOUND]: (state, action) => {
        state.clientStatus.sound = action.payload;
    },
    [Manager.CHANGE_UPDATE_CLIENTSTATUS_TYPE]: (state, action) => {
        state.clientStatus.type = action.payload;
    },

    [Manager.SIGN_IN_SUCCESS]: (state, action) => {
        // 토크 정보 저장
        state.token.accessToken = action.payload.access_token;
        state.token.tokenType = action.payload.tokenType;
        state.token.refreshToken = action.payload.refresh_token;
        state.token.expires = moment().add(action.payload.expires_in, 's').unix();

        // 관리자 정보 저장
        state.manager.managerIdx = action.payload.managerIdx;
        state.manager.managerId = action.payload.managerId;
        state.manager.managerName = action.payload.managerName;
        state.manager.managerType = action.payload.managerType;
        state.manager.shopGuid = action.payload.shopGuid;
        state.manager.shopName = action.payload.shopName;
        state.manager.isTestShop = action.payload.isTestShop === "1";
    },
    
    [Manager.SIGN_IN_FAILURE]: (state, action) => {
        state.manager = {
            ...state.manager, 
            signInStatus: 'failure', 
        };
        
        state.error = {
            triggered: true,
            message: action.payload
        };
    },
    
    [Manager.SIGN_OUT]: (state, action) => {
        state.error = INITIAL_STATE.error;
        state.token = INITIAL_STATE.token;
        state.manager = INITIAL_STATE.manager;
    },

    [Manager.TOKEN_REFRESH_REQUEST]: (state, action) => {
        state.error = INITIAL_STATE.error;
    },
    [Manager.TOKEN_REFRESH_SUCCESS]: (state, action) => {
        // 토크 정보 저장
        state.token.accessToken = action.payload.access_token;
        state.token.tokenType = action.payload.tokenType;
        state.token.refreshToken = action.payload.refresh_token;
        state.token.expires = moment().add(action.payload.expires_in, 's').unix();
    },
    [Manager.TOKEN_REFRESH_FAILURE]: (state, action) => {
        state.error = {
            triggered: true,
            message: action.payload
        };
    },

    [Manager.LOAD_NOTICE_POPUP_REQUEST]: (state, action) => {
        state.updatePopupData = INITIAL_STATE.updatePopupData;
    },
    [Manager.LOAD_NOTICE_POPUP_REQUEST_SUCCESS]: (state, action) => {
        state.updatePopupData.isPopup = action.payload.isPopup;

        state.updatePopupData.boardId = action.payload.boardId;
        state.updatePopupData.title = action.payload.title;
        state.updatePopupData.content = action.payload.content;
    },
    [Manager.LOAD_NOTICE_POPUP_REQUEST_FAILURE]: (state, action) => {
        state.updatePopupData.isPopup = false;
    },

    [Manager.SIGN_IN_RESET]: (state, action) => {
        state.manager.signInStatus = null;  // signInStatus 초기화
        state.error = INITIAL_STATE.error;  // 오류 초기화
    },
});

export default reducer;